module.exports = __webpack_public_path__ + "img/网易新闻_01.6ee92ed8.jpg";